export const feedArticleKeys = {
  all: ['feedArticles'] as const,
  list: (params: { feedKeyCategories: string[] }) => [...feedArticleKeys.all, params] as const
};
